import { DeltaText } from '@spotify/plugin-confidence-activity-react';
import {
  TASK_ACTIVITY_TYPES,
  createIssueUpdatesChangeExtension,
} from '@spotify/plugin-confidence-issues-react';

import { isTaskActivityType } from './issueActivityUtils';

export const TASK_STRING_CHANGE_EXTENSION = createIssueUpdatesChangeExtension({
  id: 'task-string-change',
  predicate: options =>
    isTaskActivityType(options.activity, TASK_ACTIVITY_TYPES.updated) &&
    options.change.fieldType === 'string',
  render: ({ change }) => (
    <DeltaText
      oldText={change.oldValue ?? ''}
      newText={change.newValue ?? ''}
      disableDiff
    />
  ),
});
